import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import Button from '../components/common/Button';
import FormikControl from '../components/formik/FormikControl';

// import { ENVIRONMENT } from '../ConfigVars';
// import Debug from '../components/formik/Debug';

const emptyInitialValues = {
  lastName: '',
};

const LastNameConfirmationForm = ({
  initialValues = emptyInitialValues,
  onSubmit,
}) => {
  const validationSchema = Yup.object({
    lastName: Yup.string().required('Please provide a valid last name.'),
  });
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      validateOnMount
      onSubmit={async (values, onSubmitProps) => {
        await onSubmit(values, onSubmitProps);
        onSubmitProps.setSubmitting(false);
      }}
    >
      {(formik) => (
        <Form className="flex flex-col gap-6">
          <FormikControl
            control="input"
            type="lastName"
            label="Last Name"
            name="lastName"
          />
          <div className="mt-2 w-full align-baseline">
            <Button
              variant="primary"
              text="Continue"
              type="submit"
              disabled={formik.isSubmitting || !formik.isValid}
              loading={formik.isSubmitting}
            />
          </div>
          {/* {ENVIRONMENT === 'development' && <Debug />} */}
        </Form>
      )}
    </Formik>
  );
};

LastNameConfirmationForm.propTypes = {
  initialValues: PropTypes.shape({
    lastName: PropTypes.string.isRequired,
  }),
  onSubmit: PropTypes.func.isRequired,
};

export default LastNameConfirmationForm;
